import { Typography } from "antd"
import React from "react"

import { empty } from "../../constants/placeholders"
import { useDateFormatter } from "../../hooks/use-date-formatter.tsx"

const { Text } = Typography

interface CreatedCellProps {
  value?: string | null
}

/**
 * `created` is the one date on a lead or project row the serializer does not
 * localise, so the cell applies the account's timezone itself — otherwise a
 * record created after local midnight reads as the day before.
 *
 * A component rather than a render function because the zone comes from the
 * store: threading the formatter through the column registry would put a redux
 * dependency on every table that builds one.
 */
export const CreatedCell: React.FC<CreatedCellProps> = ({ value }) => {
  const { formatDate, dateFormat } = useDateFormatter()

  if (!value) return <>{empty}</>

  return (
    <Text ellipsis={{ tooltip: formatDate(value) as string }}>
      {formatDate(value, dateFormat) as string}
    </Text>
  )
}
